import {
	CHANGE_CONVO,
	CONVO_DETAILS,
	OFF_LOADING_THREAD,
	OFF_LOADING_CONVO,
	UPDATE_THREADS,
	UPDATE_CONVO,
	UPDATE_CONTACT,
	UPDATE_NAME,
	GET_CONVO,
	GET_CONVOS,
	ASSIGN_OLD_CONVO,
	RESET_CONVOS,
	RESET_THREAD,
	SET_CONTACT,
	THREAD_UPDATE,
	CONVO_UPDATE,
	FILTER_CONVO_LIST,
	RECEIVE_MSG,
	SET_INBOX_STATE,
	SEND_LIMIT_REACHED
} from './actions';

let defaultState = {
	convoId: null,
	convoDetails: null,
	threadsLoading: true,
	convoLoading: null,
	thread: null,
	convo: null,
	convos: null,
	oldConvoId: null,
	contact: null,
	name: null,
	contacts: [],
	filterData: {},
	contact: {},
	newContact: {},
	newConvo: false,
	newThread: false,
	newMsgContact: null,
	newMsgThread: null,
	sendLimitReached: false,
	api: ['getAllConversations']
};

export default function inbox(state = defaultState, action) {
	switch (action.type) {
		case SEND_LIMIT_REACHED:
			return {
				...state,
				sendLimitReached: action.data.sendLimitReached
			};
		case SET_INBOX_STATE:
			return {
				...state,
				...action.data
			};
		case RECEIVE_MSG:
			return {
				...state,
				newMsgContact: action.data.contact,
				newMsgThread: action.data.thread
			};
		case FILTER_CONVO_LIST:
			return { ...state, filterData: action.data };
		case SET_CONTACT:
			return { ...state, contact: action.contact };
		case THREAD_UPDATE:
			const { threads } = state;
			return {
				...state,
				threads: [action.thread].concat(threads),
				newThread: true
			};
		case CONVO_UPDATE:
			return { ...state, newConvo: true, newContact: action.contact };
		case CHANGE_CONVO:
			return Object.assign({}, state, {
				convoId: action.id,
				thread: null,
				convo: null,
			});
		case CONVO_DETAILS:
			return Object.assign({}, state, {
				convoDetails: action.body,
			});
		case OFF_LOADING_THREAD:
			return Object.assign({}, state, {
				threadsLoading: action.status,
			});
		case OFF_LOADING_CONVO:
			return Object.assign({}, state, {
				convoLoading: action.status,
			});
		case UPDATE_THREADS:
			return Object.assign({}, state, {
				thread: action.thread,
			});
		case UPDATE_CONVO:
			return Object.assign({}, state, {
				convos: null,
				convo: action.convo,
			});
		case UPDATE_CONTACT:
			return Object.assign({}, state, {
				contact: action.contact,
			});
		case UPDATE_NAME:
			return Object.assign({}, state, {
				name: action.name,
			});
		case GET_CONVO:
			return Object.assign({}, state, {
				convos: action.convo,
				api: action.api,
			});
		case GET_CONVOS:
			return Object.assign({}, state, {
				convos: action.convos,
				api: action.api,
			});
		case ASSIGN_OLD_CONVO:
			return Object.assign({}, state, {
				oldConvoId: action.id,
			});
		case RESET_CONVOS:
			return Object.assign({}, state, {
				convos: null,
			});
		case RESET_THREAD:
			return Object.assign({}, state, {
				thread: null,
			});
		default:
			return state;
	}
}
